module.exports = __webpack_public_path__ + "static/img/zrcs.097c2dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zrcs.jpg
// module id = LtTT
// module chunks = 2